import {
  LOAD_SECTIONS,
  SHOW_SECTION,
  CREATE_SECTION,
  UPDATE_SECTION,
  DELETE_SECTION,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    code: "",
    name: "",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SECTION.REQUEST:
    case UPDATE_SECTION.REQUEST:
    case DELETE_SECTION.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case LOAD_SECTIONS.REQUEST:
    case SHOW_SECTION.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_SECTIONS.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_SECTION.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_SECTION.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_SECTION.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_SECTION.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case LOAD_SECTIONS.FAILURE:
    case SHOW_SECTION.FAILURE:
    case CREATE_SECTION.FAILURE:
    case UPDATE_SECTION.FAILURE:
    case DELETE_SECTION.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
